
import Backward10Seconds from "../../../assets/filled/Backward10Seconds.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Backward10SecondsIcon({ className, dataTestid = "Backward10SecondsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Backward10Seconds data-testid={dataTestid} className={classes} {...rest} />
  );
}
